import reducer, { saga as sagas, actions } from './ducks';
import * as translations from './translations';
import widgets from './widgets';

export const name = 'protocolItem';
export const realName = 'protocolItem';
export { reducer, widgets, sagas, actions, translations };
export * from './routes';
